import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { ReactComponent as BankOperations } from 'images/bankOperations.svg';
import { Link } from 'react-router-dom';
import { ContextMenuButton } from 'shared/mui/ContextMenu';
import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import {
  MerchantAccountBalanceReport,
  MerchantBalanceReport,
  ProviderBalanceReport,
} from 'types/embedded/balanceReport';
import { formatInputToTimestamp } from 'utils/date';
import { convertReactAdminIdToHydraId } from 'utils/index';

type Props = {
  appliedDate?: DateRangeValue;
  timezone?: DateRangeTimezoneValue;
  merchantAccount: MerchantAccountBalanceReport;
  merchant: MerchantBalanceReport;
  provider: ProviderBalanceReport;
};

export const ContextMenuBankOperationsLink: React.FC<Props> = ({
  merchantAccount,
  provider,
  merchant,
  appliedDate,
  timezone,
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  const to = createPathWithQuery(
    {
      resource: Resources.BankOperations,
      type: 'list',
    },
    {
      filter: {
        merchantAccount: [convertReactAdminIdToHydraId(merchantAccount.id, 'merchant_accounts')],
        provider: [convertReactAdminIdToHydraId(provider.id, Resources.Providers)],
        merchant: [convertReactAdminIdToHydraId(merchant.id, Resources.Merchants)],
        'dateOfOperation[gte]': formatInputToTimestamp(appliedDate?.[0], { unit: 'seconds' }),
        'dateOfOperation[lte]': formatInputToTimestamp(appliedDate?.[1], { unit: 'seconds' }),
        timezone,
      },
    },
  );

  return (
    <Link style={{ textDecoration: 'none' }} target="_blank" to={to}>
      <ContextMenuButton
        icon={<BankOperations />}
        label={'Банковские операции\nза выбранный период'}
      />
    </Link>
  );
};
